<template>
	<div class="report_list">
		<card :list="dataList" />
		<van-empty v-if="dataList.length === 0" description="暂无报告"></van-empty>
	</div>
</template>
<script>
import card from './components/report-list-card.vue'
export default {
    name: 'reportList',
    components: { card },
    data () {
        return {
            dataList: []
        }
    },
    computed: {
        patientId () {
            return this.$route.params.id || this.$store.getters['account/getPatientId']
        },
    },
    created () {
        this.getDetail()
    },
    methods: {
        getDetail () {
            this.$api.report.getReportList({
                page: 1,
                limit: 999,
                patientId: this.patientId,
                orderField: 'end_time',
                orderFieldTwo: 'date_type',
            }).then(({ code, data }) => {
                if (!code) {
                    let arr = []
                    data.list.map(v => {
                        let date = this.$moment(v.endTime).format('YYYY年MM月')
                        let index = arr.findIndex(r => r.date === date)
                        if (index > -1) {
                            arr[index].list.push(v)
                        } else {
                            arr.push({
                                date,
                                list: [v]
                            })
                        }
                    })

                    this.dataList = arr
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.report_list {
	padding: 64px 32px 32px;
}
</style>